/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/control-has-associated-label */
import * as React from 'react';
import { AppContext } from '../../Context/app-state';
import './Garland-Btn.css';

export default function GarlandBtn() {
  const { garlandSettings, setGarland } = React.useContext(AppContext);
  const colorArr = ['multicolor', 'red', 'blue', 'green', 'yellow'];
  const changeGarland = (event: React.MouseEvent<HTMLElement>) => {
    setGarland({
      ...garlandSettings,
      garland: !garlandSettings.garland,
    });
  };
  const changeColor = (id: string) => {
    setGarland({ ...garlandSettings, colorGarland: id });
  };
  const chooseGarland = colorArr.map((str) => (
    <button
      onClick={() => {
        changeColor(str);
      }}
      id={str}
      className={`garland-color btn-${str}`}
      type="button"
    />
  ));
  return (
    <div className="App-tree__garland">
      <div className="App-tree__garland-btn">{chooseGarland}</div>
      <h5 className="App-tree__garland-off">выкл</h5>
      <label className="switch__garland-off">
        <input type="checkbox" onClick={changeGarland} />
        <span className="slider round" />
      </label>
      <h5 className="App-tree__garland-on">вкл</h5>
    </div>
  );
}
